<template>
    <div :style="note">
        <div class="login_header-logo">
            <img src="@/assets/img/logoNew.png" alt="logo" class="logo-img">
            <router-link to="/" class="site-title">数据资产全过程AI服务平台</router-link>
        </div>
        <el-form :rules="rules" ref="loginForm" v-loading="loading" element-loading-text="正在登录..."
            element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" :model="loginForm"
            class="login_Container">
            <div style="text-align: center;">
                <el-tabs v-model="activeTab" @tab-click="handleTabClick" style="width: 100%; margin: 0 0 20px 0;">
                    <el-tab-pane label="账号登录" name="account">
                        <el-form-item prop="username" style="margin: 15px 0;">
                            <el-input size="normal" type="text" v-model="loginForm.username" auto-complete="off"
                                placeholder="请输入账号" clearable prefix-icon="el-icon-user"
                                @keydown.enter.native="submitLogin"></el-input>
                        </el-form-item>
                        <el-form-item prop="password" style="margin: 15px 0;">
                            <el-input size="normal" type="password" v-model="loginForm.password" auto-complete="off"
                                placeholder="请输入密码" clearable prefix-icon="el-icon-lock"
                                @keydown.enter.native="submitLogin"></el-input>
                        </el-form-item>
                        <el-form-item style="margin: 15px 0;">
                            <el-col :span="15">
                                <el-form-item prop="imageCode">
                                    <el-input size="normal" type="text" v-model="loginForm.imageCode"
                                        auto-complete="off" placeholder="请输入图片验证码" clearable
                                        prefix-icon="el-icon-picture" @keydown.enter.native="submitLogin"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <img id="img" alt="显示失败" :src="codeURL" @click="refreshCaptcha"
                                    style="height: 40px; cursor: pointer;" />
                            </el-col>
                        </el-form-item>
                    </el-tab-pane>
                    <el-tab-pane label="" name="phone">
                        <el-form-item prop="phone" style="margin: 15px 0;">
                            <el-input size="normal" type="text" v-model="loginForm.phone" auto-complete="off"
                                placeholder="请输入手机号" clearable prefix-icon="el-icon-mobile-phone"
                                @keydown.enter.native="submitLogin"></el-input>
                        </el-form-item>
                        <el-form-item prop="imageCode" style="margin: 15px 0;">
                            <el-col :span="15">
                                <el-input size="normal" type="text" v-model="loginForm.imageCode" auto-complete="off"
                                    placeholder="请输入图片验证码" clearable prefix-icon="el-icon-picture"></el-input>
                            </el-col>
                            <el-col :span="8">
                                <img id="img" alt="显示失败" :src="codeURL" @click="refreshCaptcha"
                                    style="height: 40px; cursor: pointer;" />
                            </el-col>
                        </el-form-item>
                        <el-form-item prop="smsCode" style="margin: 15px 0;">
                            <el-col :span="16">
                                <el-input size="normal" type="text" v-model="loginForm.smsCode" auto-complete="off"
                                    placeholder="请输入短信验证码" clearable prefix-icon="el-icon-message"></el-input>
                            </el-col>
                            <el-col :span="8">
                                <el-button size="normal" @click="getSMSCode" :disabled="smsDisabled"
                                    style="width: 100%;">
                                    {{ smsBtnText }}
                                </el-button>
                            </el-col>
                        </el-form-item>
                    </el-tab-pane>
                </el-tabs>

                <el-button size="normal" type="primary"
                    style="width: 100%; margin: 15px 0; height: 45px; font-size: 16px;" @click="submitLogin"
                    :disabled=forbidLogin>登录</el-button>

                <div style="display: flex; justify-content: space-between; margin: 10px 0; height: 50px; ">
                    <el-link type="primary" @click="showForgetDialog" style="font-size: 14px;">忘记账号或密码？</el-link>
                    <el-link type="primary" @click="registerAccount" style="font-size: 14px;">注册账号</el-link>
                </div>

                <el-dialog :visible.sync="forgetDialogVisible" width="1000px" :show-close="false"
                    custom-class="forget-dialog" top="40vh">
                    <div slot="title" style="text-align: right;">
                        <el-button type="text" @click="forgetDialogVisible = false" style="padding: 0;">
                            <i class="el-icon-close" style="font-size: 18px;"></i>
                        </el-button>
                    </div>
                    <div style="text-align: center; margin-bottom: 20px;">
                        <div style="display: flex; justify-content: center; margin-bottom: 30px;">
                            <div v-for="(step, index) in forgetSteps" :key="index"
                                style="display: flex; align-items: center;">
                                <div :style="{
                                    width: '30px',
                                    height: '30px',
                                    borderRadius: '50%',
                                    background: currentForgetStep >= index ? '#409EFF' : '#C0C4CC',
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '5px',
                                    fontSize: '14px'
                                }">
                                    {{ index + 1 }}
                                </div>
                                <span :style="{
                                    color: currentForgetStep >= index ? '#409EFF' : '#C0C4CC',
                                    marginRight: '10px',
                                    fontWeight: currentForgetStep >= index ? 'bold' : 'normal'
                                }">
                                    {{ step.title }}
                                </span>
                                <div v-if="index < forgetSteps.length - 1" :style="{
                                    width: '60px',
                                    height: '2px',
                                    background: currentForgetStep > index ? '#409EFF' : '#C0C4CC',
                                    marginRight: '10px'
                                }"></div>
                            </div>
                        </div>

                        <!-- 第一步：输入企业信息 -->
                        <div v-if="currentForgetStep === 0" style="padding: 0 30px;">
                            <el-form :model="forgetForm" :rules="forgetRules" ref="forgetStep1Form">
                                <el-form-item prop="companyName" label="企业名称" label-width="160px">
                                    <el-input v-model="forgetForm.companyName" placeholder="请输入企业全称"></el-input>
                                </el-form-item>
                                <el-form-item prop="creditCode" label="统一社会信用代码" label-width="160px">
                                    <el-input v-model="forgetForm.creditCode" placeholder="请输入统一社会信用代码"
                                        :disabled="forgetForm.noCreditCode">
                                        <template slot="append">
                                            <el-checkbox v-model="forgetForm.noCreditCode">无统一社会信用代码</el-checkbox>
                                        </template>
                                    </el-input>
                                </el-form-item>
                            </el-form>
                        </div>

                        <!-- 第二步：验证信息 -->
                        <div v-if="currentForgetStep === 1" style="padding: 0 30px;">
                            <el-form :model="forgetForm" :rules="forgetRules" ref="forgetStep2Form">
                                <el-form-item label="账号名称" label-width="120px">
                                    <el-input v-model="forgetForm.username" disabled></el-input>
                                </el-form-item>
                                <el-form-item label="注册手机号" label-width="120px">
                                    <el-input :value="forgetForm.phone | phoneFormat" disabled></el-input>
                                </el-form-item>
                                <el-form-item prop="smsCode" label="短信验证码" label-width="120px">
                                    <el-col :span="14">
                                        <el-input v-model="forgetForm.smsCode" placeholder="请输入6位验证码"></el-input>
                                    </el-col>
                                    <el-col :span="10">
                                        <el-button @click="sendForgetSms" :disabled="forgetSmsDisabled"
                                            style="width:100%">
                                            {{ forgetSmsBtnText }}
                                        </el-button>
                                    </el-col>
                                </el-form-item>
                            </el-form>
                        </div>

                        <!-- 第三步：重置密码 -->
                        <div v-if="currentForgetStep === 2" style="padding: 0 30px;">
                            <el-form :model="forgetForm" :rules="forgetRules" ref="forgetStep3Form">
                                <el-form-item label="账号名称" label-width="120px">
                                    <el-input v-model="forgetForm.username" disabled></el-input>
                                </el-form-item>
                                <el-form-item label="注册手机号" label-width="120px">
                                    <el-input v-model="forgetForm.phone" disabled></el-input>
                                </el-form-item>
                                <el-form-item prop="newPassword" label="新密码" label-width="120px">
                                    <el-input type="password" v-model="forgetForm.newPassword"
                                        placeholder="6-20位字母、数字或符号组合"></el-input>
                                </el-form-item>
                                <el-form-item prop="confirmPassword" label="确认密码" label-width="120px">
                                    <el-input type="password" v-model="forgetForm.confirmPassword"
                                        placeholder="请再次输入新密码"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>

                        <!-- 第四步：完成 -->
                        <div v-if="currentForgetStep === 3" style="text-align: center; padding: 40px 0;">
                            <i class="el-icon-success" style="font-size: 80px; color: #67C23A;"></i>
                            <h3 style="margin: 20px 0; color: #67C23A;">密码重置成功</h3>
                            <p style="color: #606266;">您可以使用新密码登录系统</p>
                        </div>
                    </div>

                    <div slot="footer" style="text-align: center;">
                        <el-button v-if="currentForgetStep > 0" @click="prevForgetStep"
                            style="margin-right: 20px;">上一步</el-button>
                        <el-button type="primary" @click="nextForgetStep">
                            {{ currentForgetStep === forgetSteps.length - 1 ? '完成' : '下一步' }}
                        </el-button>
                    </div>
                </el-dialog>
            </div>
        </el-form>
        <div class="login-side-text">
            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数据资产全过程AI服务平台依托区块链、大数据、人工智能等前沿技术，平台核心功能覆盖并支撑数据资产录入、受理、审核、公示、转移、变更等全过程，面向全国提供数据资产登记服务。
            </p>
        </div>
        <div class="login_footer">
            © 2025 数据资产全过程AI服务平台 版权所有 隐私政策 冀ICP备2025125156号
        </div>
    </div>

</template>

<script>
export default {
    name: "Login",
    data() {
        return {
            codeURL: '', // 将通过axios获取
            loginUrl: 'login',
            loading: false,
            forbidLogin: true,
            loginForm: {
                username: '',
                password: '',
                phone: '',
                imageCode: '',
                smsCode: '',
                rememberMe: true
            },
            rules: {
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                imageCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
                smsCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
            },
            forgetRules: {
                username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ]
            },
            forgetForm: {
                companyName: '',
                creditCode: '',
                noCreditCode: false,
                phone: '',
                smsCode: '',
                newPassword: '',
                confirmPassword: ''
            },
            forgetRules: {
                companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
                creditCode: [
                    {
                        required: true,
                        message: '请输入统一社会信用代码',
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (this.forgetForm.noCreditCode || value) {
                                callback();
                            } else {
                                callback(new Error('请输入统一社会信用代码'));
                            }
                        }
                    }
                ],
                smsCode: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }],
                newPassword: [
                    { required: true, message: '请输入新密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '请再次输入新密码', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (value !== this.forgetForm.newPassword) {
                                callback(new Error('两次输入密码不一致'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },
            forgetDialogVisible: false,
            currentForgetStep: 0,
            forgetSteps: [
                { title: '输入企业信息' },
                { title: '手机验证' },
                { title: '重置密码' },
                { title: '完成' }
            ],
            forgetSmsDisabled: false,
            forgetSmsBtnText: '获取验证码',
            forgetCountdown: 60,
            activeTab: 'account',
            smsDisabled: false,
            smsBtnText: '获取验证码',
            countdown: 60,
            note: {
                backgroundImage: "url(" + require("../assets/img/login-bg.jpg") + ")",
                backgroundColor: "#f9f9f9",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                position: "absolute",
                backgroundSize: "cover",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minWidth: "100%",
                overflowX: "hidden"
            }
        }
    },
    mounted() {
        this.refreshCaptcha(); // 初始化加载验证码
        this.getBlacklist(); // 获取黑名单
    },
    watch: {
        'loginForm.username': function (val, oldValue) {
            this.forbidLogin = !this.checkData();
        },
        'loginForm.password': function (val, oldValue) {
            this.forbidLogin = !this.checkData();
        },
        'loginForm.imageCode': function (val, oldValue) {
            this.forbidLogin = !this.checkData();
        },
        'forgetForm.noCreditCode': function (val) {
            if (val) {
                this.forgetForm.creditCode = '';
                this.$refs.forgetStep1Form.clearValidate(['creditCode']);
            }
        }
    },
    filters: {
        phoneFormat(value) {
            if (!value) return '';
            // 处理已经脱敏的手机号
            if (value.includes('****')) return value;
            return value.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2');
        }
    },
    methods: {
        checkData() {
            if (this.activeTab === 'account') {
                return this.loginForm.username !== '' && this.loginForm.password !== '' && this.loginForm.imageCode !== '';
            } else {
                return this.loginForm.phone !== '' && this.loginForm.imageCode !== '' && this.loginForm.smsCode !== '';
            }
        },
        handleTabClick(tab) {
            this.$refs.loginForm.clearValidate();
        },
        showForgetDialog() {
            this.forgetDialogVisible = true;
            this.$nextTick(() => {
                this.$refs.forgetForm.resetFields();
            });
        },
        showForgetDialog() {
            this.forgetDialogVisible = true;
            this.currentForgetStep = 0;
            this.forgetForm = {
                companyName: '',
                creditCode: '',
                noCreditCode: false,
                phone: '',
                smsCode: '',
                newPassword: '',
                confirmPassword: ''
            };
        },

        prevForgetStep() {
            this.currentForgetStep--;
        },

        nextForgetStep() {
            if (this.currentForgetStep === 0) {
                this.$refs.forgetStep1Form.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.$axios.get(`/web/account/forgot/checkCompanyName?companyName=${this.forgetForm.companyName}&creditCode=${this.forgetForm.creditCode}`)
                            .then(response => {
                                this.loading = false;
                                //console.log(response.data.status);
                                //console.log(response.data.msg);

                                if (response.data.status === 200) {
                                    this.forgetForm.username = response.data.object.userName;
                                    this.forgetForm.phone = response.data.object.phone;
                                    this.currentForgetStep++;
                                } else {
                                    this.$message.error(response.data.msg || '企业信息不存在，请输入正确的企业信息');
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message.error(error.response?.data?.msg || '企业信息验证失败');
                            });
                    }
                });
            } else if (this.currentForgetStep === 1) {
                this.$refs.forgetStep2Form.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.$axios.get(`/web/account/forgot/checkVerificationCode?username=${this.forgetForm.username}&phone=${this.forgetForm.phone}&code=${this.forgetForm.smsCode}`)
                            .then(response => {
                                this.loading = false;
                                if (response.data.status === 200) {
                                    this.currentForgetStep++;
                                } else {
                                    this.$message.error(response.data.object || '验证码错误');
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message.error(error.response?.data?.object || '验证码验证失败');
                            });
                    }
                });
            } else if (this.currentForgetStep === 2) {
                this.$refs.forgetStep3Form.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.$axios.get(`/web/account/forgot/resetPassword?username=${this.forgetForm.username}&newPassword=${this.forgetForm.newPassword}`)
                            .then(response => {
                                this.loading = false;
                                if (response.data.status === 200) {
                                    this.currentForgetStep++;
                                } else {
                                    this.$message.error(response.data.object || '密码重置失败');
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message.error(error.response?.data?.object || '密码重置失败');
                            });
                    }
                });
            } else if (this.currentForgetStep === 3) {
                this.forgetDialogVisible = false;
                this.currentForgetStep = 0;
            }
        },

        sendForgetSms() {
            this.forgetSmsDisabled = true;
            this.forgetSmsBtnText = `${this.forgetCountdown}秒后重新获取`;

            this.$axios.get(`/web/account/forgot/getVerificationCode?username=${this.forgetForm.username}&phone=${this.forgetForm.phone}`)
                .then(response => {
                    if (response.data.status === 200) {
                        const timer = setInterval(() => {
                            this.forgetCountdown--;
                            this.forgetSmsBtnText = `${this.forgetCountdown}秒后重新获取`;

                            if (this.forgetCountdown <= 0) {
                                clearInterval(timer);
                                this.forgetSmsDisabled = false;
                                this.forgetSmsBtnText = '获取验证码';
                                this.forgetCountdown = 60;
                            }
                        }, 1000);
                        this.$message.success('验证码已发送');
                    } else {
                        this.forgetSmsDisabled = false;
                        this.$message.error(response.data.msg || '验证码发送失败');
                    }
                })
                .catch(error => {
                    this.forgetSmsDisabled = false;
                    this.$message.error(error.response?.data?.msg || '验证码发送失败');
                });
        },
        getSMSCode() {
            if (!this.loginForm.phone) {
                this.$message.error('请输入手机号');
                return;
            }
            if (!this.loginForm.imageCode) {
                this.$message.error('请输入图片验证码');
                return;
            }

            this.smsDisabled = true;
            const timer = setInterval(() => {
                this.countdown--;
                this.smsBtnText = `${this.countdown}秒后重新获取`;
                if (this.countdown <= 0) {
                    clearInterval(timer);
                    this.smsDisabled = false;
                    this.smsBtnText = '获取验证码';
                    this.countdown = 60;
                }
            }, 1000);

            this.$axios.get('/web/company/user/sendCode?phone=' + this.loginForm.phone).then(response => {
                if (response.data.status === 200) {
                    this.$message.success('验证码已发送');
                } else {
                    clearInterval(timer);
                    this.smsDisabled = false;
                    this.smsBtnText = '获取验证码';
                    this.countdown = 60;
                    this.$message.error(response.data.msg || '验证码发送失败');
                }
            }).catch(error => {
                clearInterval(timer);
                this.smsDisabled = false;
                this.smsBtnText = '获取验证码';
                this.countdown = 60;
                this.$message.error(error.response?.data?.msg || '验证码发送失败');
            });
        },
        refreshCaptcha() {
            const timestamp = new Date().getTime();
            this.$axios.get('/web/createImageCode', {
                params: { t: timestamp },
                responseType: 'blob',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Accept': 'image/jpeg',
                    'X-Forwarded-For': window.location.hostname
                },
                withCredentials: true
            }).then(response => {
                // 检查响应状态和内容类型
                if (!response.data || !response.data.size ||
                    !response.headers['content-type'].includes('image/')) {
                    throw new Error('Invalid image response');
                }
                // 释放之前的URL对象
                if (this.codeURL) {
                    URL.revokeObjectURL(this.codeURL);
                }
                this.codeURL = URL.createObjectURL(response.data);
                // 自动清除内存
                setTimeout(() => {
                    if (this.codeURL) {
                        URL.revokeObjectURL(this.codeURL);
                    }
                }, 60000); // 1分钟后自动释放
            }).catch(error => {
                console.error('验证码获取失败:', error);
                this.$message.error('验证码获取失败');
                // 失败时显示默认图片
                this.codeURL = require('../assets/img/nothing.png');
            });
        },
        registerAccount() {
            //console.log('尝试跳转到注册页面');
            //console.log('当前路由对象:', this.$router);
            //console.log('路由配置:', this.$router.options.routes);

            if (this.$router) {
                this.$router.push('/register').then(() => {
                    //console.log('路由跳转成功');
                }).catch(err => {
                    console.error('路由跳转失败:', err);
                    this.$message.error('跳转失败，请检查路由配置');
                    window.location.href = '/register';
                });
            } else {
                console.warn('Vue Router不可用，使用原生跳转');
                window.location.href = '/register';
            }
        },
        getBlacklist() {
            this.getRequest('/web/company/user/getBlacklist').then(resp => {
                if (resp && Array.isArray(resp.data)) {
                    this.blacklist = resp.data; // 直接使用返回的数组
                }
            });
        },
        isBlacklisted(username) {
            return this.blacklist && this.blacklist.includes(username);
        },
        submitLogin() {
            this.$refs.loginForm.validate((valid) => {
                if (this.activeTab === 'account' && this.isBlacklisted(this.loginForm.username)) {
                    this.$message.error("账号或密码错误");
                    return false;
                }
                this.loading = true;

                if (this.activeTab === 'account') {
                    this.postKeyValueRequest('/web/doLogin', this.loginForm).then(resp => {
                        this.loading = false;
                        if (resp) {
                            var user = resp.data.user;
                            if (user.avatar === '') {
                                user.avatar = require('../assets/user_pic_middle.gif');
                            }
                            this.$store.commit('INIT_USER', JSON.stringify(user));
                            this.$router.push('/home');
                        }
                    }).catch(() => {
                        this.loading = false;
                    });
                } else {
                    this.$axios.post('/web/account/loginByPhone?phone=' + this.loginForm.phone + '&smsCode=' +
                        this.loginForm.smsCode + '&imageCode=' + this.loginForm.imageCode).then(resp => {
                            //console.log("wancgheng");
                            this.loading = false;
                            if (resp.data.status === 200) {
                                var user = resp.data.object;
                                if (!user) {
                                    this.$message.error('获取用户信息失败');
                                    return;
                                }
                                // 确保用户信息包含必要字段
                                user = {
                                    ...user,
                                    username: user.username || user.phone,
                                    roles: user.roles || [],
                                    permissions: user.permissions || [],
                                    rememberMe: this.loginForm.rememberMe
                                };
                                if (user.avatar === '') {
                                    user.avatar = require('../assets/user_pic_middle.gif');
                                }
                                this.$store.commit('INIT_USER', JSON.stringify(user));
                                this.$router.push('/home');
                            } else {
                                this.$message.error(resp.data.msg || '登录失败');
                            }
                        }).catch(error => {
                            this.loading = false;
                            this.$message.error(error.response?.data?.msg || '登录失败');
                        });
                }
            });
        }
    }
}
</script>

<style>
.login_header-logo {
    position: absolute;
    top: 1px;
    left: 10px;
    display: flex;
    align-items: flex-start;
    z-index: 10;
}

.logo-img {
    width: 60px;
    height: 60px;
    margin-right: 15px;
}

.site-title {
    font-size: 23px;
    color: #26292c;
    font-weight: bold;
    text-decoration: none;
    cursor: pointer;
    margin-top: 23px;
}

.site-title:hover {
    color: #26292c;
}

.login-text {
    color: #666;
    font-weight: normal;
}

.login_Container {
    border-radius: 8px;
    width: 380px;
    min-height: 480px;
    padding: 40px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    position: relative;
    right: 10%;
    top: 1%;
}

@media (max-width: 1200px) {
    .login_Container {
        right: 5%;
    }

    .login-side-text {
        right: 5%;
    }
}

@media (max-width: 992px) {
    .login_Container {
        right: 0;
        margin: 0 auto;
    }

    .login-side-text {
        display: none;
    }
}

@media (max-width: 576px) {
    .login_Container {
        width: 90%;
        padding: 20px;
        min-height: auto;
    }
}

.forget-dialog {
    margin-top: 30vh !important;
}

.forget-dialog .el-dialog__body {
    padding: 30px 40px;
}

.el-tabs__item {
    font-size: 18px;
    padding: 0 25px;
    color: #666;
    transition: all 0.3s;
    font-weight: 500;
    text-align: center;
}

.el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #e4e7ed;
}

.el-tabs__active-bar {
    height: 3px;
    background-color: #409EFF;
    bottom: 0;
}

.el-tabs__item.is-active {
    color: #409EFF;
    font-weight: 600;
}

.el-tabs__item:hover {
    color: #409EFF;
    font-weight: 600;
}

.login-side-text {
    position: absolute;
    right: 23%;
    top: 55%;
    transform: translateY(-50%);
    width: 370px;
    color: #333;
    padding: 20px;
    border-radius: 8px;
    white-space: normal;
    word-wrap: break-word;
    max-width: 100%;
}

@media (max-width: 992px) {
    .login-side-text {
        display: none;
    }
}

.login-side-text h2 {
    font-size: 22px;
    color: #1890ff;
    margin-bottom: 20px;
}

.login-side-text p {
    font-size: 16px;
    line-height: 1.8;
    color: #666;
}

.loginTitle {
    margin: 15px auto 20px auto;
    text-align: center;
    color: #505458;
}

.loginRemember {
    text-align: left;
    margin: 0 0 15px 0;
}

.login_footer {
    position: absolute;
    bottom: 20px;
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #6b6969;
}
</style>